// --- simple parser array body for back
export const splitHtmlByBlocks = (html: string): string[] => {
  if (!html) return [];
  const div = document.createElement("div");
  div.innerHTML = html.trim();
  const blocks: string[] = [];

  div.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      const tag = el.tagName.toLowerCase();
      if (["p", "ul", "ol"].includes(tag)) {
        blocks.push(el.outerHTML);
      }
    }
  });

  return blocks;
};

// --- parser array body for preview + convertation pt to rem
export const splitHtmlByBlocksWithFontConvert = (
  html: string,
  // isFontSizeConvert: boolean
): string[] => {
  if (!html) return [];
  const div = document.createElement("div");
  div.innerHTML = html.trim();
  const blocks: string[] = [];

  div.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      const tag = el.tagName.toLowerCase();

      if (["p", "ul", "ol"].includes(tag)) {
        // ищем все span с inline-стилем внутри (включая li)
        const spans = el.querySelectorAll("span[style]");
        spans.forEach((spanNode) => {
          const span = spanNode as HTMLElement;
          const fontSize = span.style.fontSize;

          if (fontSize) {
            const ptValue = parseInt(fontSize, 10);
            // console.log(ptValue);

            const remValue = (ptValue * 0.06).toFixed(3); // pt → rem
            // console.log(remValue);

            span.style.fontSize = `${remValue}rem`;
          }
        });

        blocks.push(el.outerHTML);
      }
    }
  });

  return blocks;
};
